export default "__VITE_ASSET__DGrIDZCm__"